var dd = require('react-dd');

module.exports = dd.createClass({
	render: function(){
		return dd.div({
				style: {overflowY: 'auto', height: '100%', maxHeight: '100%', minHeight: '100%'},
				onScroll: this.props.onScroll || null
			},
			this.props.children
		);
	}
});



//////////////////
// WEBPACK FOOTER
// ./~/ES/widgets/VerticalScroll.js
// module id = 66
// module chunks = 0 1 2 3 4